import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { TOP_NAV_HEIGHT, TopNavBarZIndex, TOP_NAV_BAR_LITE_VERSION } from '../../utils/TopNavBarConfig';
import { getTopNavBarUrl } from '../../utils/pathsUtil';

/**
 * Wrapper component for the top nav bar plugin.
 * The plugin script injects HTML directly into this div.
 * This replaces the iframe-based TopNavBar implementation.
 * Adapted from pathfinder-ui's TopNavBarPluginWrapper.
 */
interface TopNavBarPluginWrapperProps {
  hide?: boolean;
}

const TopNavBarPluginWrapper: React.FC<TopNavBarPluginWrapperProps> = ({ hide = false }) => {
  useEffect(() => {
    if (TOP_NAV_BAR_LITE_VERSION) {
      const bodyElm = document.body;
      if (bodyElm && !bodyElm.classList.contains('tnb-lite-version')) {
        bodyElm.classList.add('tnb-lite-version');
      } 
    }
  }, []);

  const topNavBarUrl = getTopNavBarUrl();
  const pluginScriptUrl = TOP_NAV_BAR_LITE_VERSION ? `${topNavBarUrl}/plugin-lite/init.js` : `${topNavBarUrl}/plugin/init.js`;

  return (
    <>
      <Helmet>
        {/* This script injects the top nav bar html directly into page body or #top-nav-bar-wrapper if present */}
        <script src={pluginScriptUrl} async />
      </Helmet>
      <div
        id='top-nav-bar-wrapper'
        style={{
          height: TOP_NAV_HEIGHT,
          minHeight: TOP_NAV_HEIGHT,
          overflow: 'visible',
          position: 'relative',
          zIndex: TopNavBarZIndex,
          display: hide ? 'none' : 'block',
        }}
      />
    </>
  );
};

export default TopNavBarPluginWrapper;
